<script setup>
import { ref, defineEmits, defineProps } from 'vue';
import { useRouter } from 'vue-router';
import { $api } from '@/services';
import Multiselect from '@suadelabs/vue3-multiselect';

const answerSelected = ref('scratch');
const emit = defineEmits(['close']);
const props = defineProps({
	listSurveyTemplateByLuca: {
		type: Array,
		required: true,
	},
	listSurveyTemplateByCenter: {
		type: Array,
		required: true,
	},
});
const router = useRouter();
const selectedTemplate = ref(null);

const submit = async () => {
	if (answerSelected.value === 'scratch') {
		router.push('/survey/create');
	} else {
		router.push('/survey/create?templateId=' + selectedTemplate.value.id);
	}
};
</script>
<template>
	<div class="_create-boarding _modal bg-white">
		<div
			class="_modal__content px-12 py-6 flex flex-col items-center justify-center"
		>
			<div>
				<img
					class="w-16 h-16"
					alt="Luca Education"
					src="@/assets/images/illustrations/create.png"
					title="Luca Education"
				/>
			</div>
			<div
				class="_modal__content__title text-neutral-700 font-semibold text-2xl mt-5 text-center"
			>
				Tạo phiếu khảo sát
			</div>
		</div>
		<div class="flex items-center justify-around gap-4 px-12 pb-6">
			<div
				class="text-neutral-600 whitespace-nowrap flex items-center text-lg gap-2 cursor-pointer"
				@click="answerSelected = 'scratch'"
			>
				<input
					value="scratch"
					name="answer"
					type="radio"
					class="h-4 w-4 text-yellow-600 border-neutral-400 border-2 focus:ring-yellow-600"
					v-model="answerSelected"
				/>
				<div class="text-sm">Tạo mới</div>
			</div>
			<div
				class="text-neutral-600 whitespace-nowrap flex items-center text-lg gap-2 cursor-pointer"
				@click="answerSelected = 'use-luca-template'"
				v-if="props.listSurveyTemplateByLuca.length > 0"
			>
				<input
					value="use-luca-template"
					name="answer"
					type="radio"
					class="h-4 w-4 text-yellow-600 border-neutral-400 border-2 focus:ring-yellow-600"
					v-model="answerSelected"
				/>
				<div class="text-sm">Mẫu của Luca</div>
			</div>
			<div
				class="text-neutral-600 whitespace-nowrap flex items-center text-lg gap-2 cursor-pointer"
				@click="answerSelected = 'use-center-template'"
				v-if="props.listSurveyTemplateByCenter.length > 0"
			>
				<input
					value="use-center-template"
					name="answer"
					type="radio"
					class="h-4 w-4 text-yellow-600 border-neutral-400 border-2 focus:ring-yellow-600"
					v-model="answerSelected"
				/>
				<div class="text-sm">Mẫu của trung tâm</div>
			</div>
		</div>
		<div v-if="answerSelected !== 'scratch'" class="px-12 pb-12">
			<div class="flex items-center gap-3">
				<div
					class="text-neutral-400 font-semibold text-xs whitespace-nowrap"
				>
					MẪU KHẢO SÁT
				</div>
				<Multiselect
					v-model="selectedTemplate"
					:options="
						answerSelected === 'use-luca-template'
							? props.listSurveyTemplateByLuca
							: props.listSurveyTemplateByCenter
					"
					track-by="id"
					label="name"
					placeholder="Chọn mẫu khảo sát"
					selectLabel=""
					deselectLabel="Xoá"
					selectedLabel=""
				/>
			</div>
		</div>
		<div
			class="_modal__footer px-12 py-6 bg-neutral-50 flex flex-nowrap items-center"
		>
			<button
				class="button-p text-center mr-3 bg-none shadow-none text-neutral-500 hover:text-neutral-700"
				type="button"
				@click="$emit('close')"
			>
				Thoát
			</button>
			<button
				class="button-p text-center whitespace-nowrap"
				:disabled="!selectedTemplate && answerSelected !== 'scratch'"
				type="button"
				@click="submit"
			>
				Xác nhận
			</button>
		</div>
	</div>
</template>
